// colorConst.ts
// Shotaro Ito

export let appThemaColors = {
  default: "#0B7C8C",
  aal_operator: "#426a5a",
  fulltech: "#8d0801",
  owner: "#16425b",
  haudi: "#50A69F",
  sci_operator: "#e2711d",
};

export let muiThemeColors = {
  palette: {
    primary: {
      main: "#3A546E",
    },
    secondary: {
      main: "#E66C4F",
    },
  },
};

export const rowStyles = {
  backgroundColor: {
    even: "#FFFFFF",
    odd: "#F5F5F5",
  },
};

export const kColorReset = "\u001b[0m";
export const kColorBlack = "\u001b[30m";
export const kColorRed = "\u001b[31m";
export const kColorGreen = "\u001b[32m";
export const kColorYellow = "\u001b[33m";
export const kColorBlue = "\u001b[34m";
export const kColorMagenta = "\u001b[35m";
export const kColorCyan = "\u001b[36m";
export const kColorWhite = "\u001b[37m";
